import { Component, OnInit, ViewEncapsulation, Input, Injector, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormArray } from '@angular/forms';
import { merge, Subject } from 'rxjs';
import { startWith, tap, switchMap, takeUntil } from 'rxjs/operators';
import { DropdownsService } from 'app/services/dropdowns.service';
import { OwnersCreateComponent } from '../../owners-create.component';
import { remove } from 'lodash';
import { FuseUtils } from '@fuse/utils';
import { TranslateService } from '@ngx-translate/core';
@Component({
    selector: 'tab-contact',
    templateUrl: './tab-contact.component.html',
    styleUrls: ['./tab-contact.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class TabContactComponent implements OnInit, OnDestroy {
    @Input() form: UntypedFormGroup;
    partners: UntypedFormArray;
    public countries: any = [];
    public searching: boolean;
    public countrySearch: UntypedFormControl = new UntypedFormControl();
    public cities: any = [];
    public citySearch: UntypedFormControl = new UntypedFormControl();
    public provinces: any = [];
    public provinceSearch: UntypedFormControl = new UntypedFormControl();
    public regions: any = [];
    public regionSearch: UntypedFormControl = new UntypedFormControl();
    public languages: any = [];
    public communicationLanguages: any = [];
    public languagesSearch: UntypedFormControl = new UntypedFormControl();
    _ownersCreateComponent: OwnersCreateComponent;
    givenData = [] as any;
    systemlang: any;
    searchLanguages: UntypedFormControl = new UntypedFormControl('');
    private _unsubscribeAll: Subject<any>;
    constructor(
        private _dropdownsService: DropdownsService,
        private injector: Injector,
        private _translateService: TranslateService,
    ) {
        this.systemlang = this._translateService.currentLang;
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        this._translateService.onLangChange
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe(() => {
            this.systemlang = this._translateService.currentLang === 'es' ? 'es_AR' : this._translateService.currentLang;
        });
        if (!this.form) {
            this._ownersCreateComponent = this.injector.get(OwnersCreateComponent) as OwnersCreateComponent;
            this.form = this._ownersCreateComponent.form;
        }
        if ((this.form.get('language_value').value)) {
            this.givenData.push(this.form.get('language_value').value);
        }

        this.partners = this.form.get('partners') as UntypedFormArray;
        merge(this.countrySearch.valueChanges, this.form.get('country').valueChanges)
            .pipe(
                startWith(''),
                tap(() => this.searching = true),
                switchMap(() => {
                    let search = this.form.get('country').value;
                    if (this.countrySearch.value) {
                        search = this.countrySearch.value;
                    }
                    return this._dropdownsService.getCountries(search);
                })
            )
            .subscribe((data: any) => {
                this.searching = false;
                this.countries = data.docs;
            });


        merge(this.citySearch.valueChanges, this.form.get('city').valueChanges, this.form.get('province').valueChanges)
            .pipe(
                startWith(''),
                tap(() => this.searching = true),
                switchMap(() => {
                    let search = this.form.get('city').value;
                    if (this.citySearch.value) {
                        search = this.citySearch.value;
                    }
                    return this._dropdownsService.getCities(search, false, false, this.form.get('province').value);
                })
            )
            .subscribe((data: any) => {
                this.searching = false;
                this.cities = data.docs;
            });

        merge(this.provinceSearch.valueChanges, this.form.get('province').valueChanges, this.form.get('region').valueChanges)
            .pipe(
                startWith(''),
                tap(() => this.searching = true),
                switchMap(() => {
                    let search = this.form.get('province').value;
                    if (this.provinceSearch.value) {
                        search = this.provinceSearch.value;
                    }
                    return this._dropdownsService.getProvinces(search, false, this.form.get('region').value);
                })
            )
            .subscribe((data: any) => {
                this.searching = false;
                this.provinces = data.docs;
            });

        merge(this.regionSearch.valueChanges, this.form.get('region').valueChanges, this.form.get('country').valueChanges)
            .pipe(
                startWith(''),
                tap(() => this.searching = true),
                switchMap(() => {
                    let search = this.form.get('region').value;
                    if (this.regionSearch.value) {
                        search = this.regionSearch.value;
                    }
                    return this._dropdownsService.getRegions(search, this.form.get('country').value);
                })
            )
            .subscribe((data: any) => {
                this.searching = false;
                this.regions = data.docs;
            });

        merge(this.languagesSearch.valueChanges, this.form.get('language').valueChanges)
            .pipe(
                startWith(''),
                tap(() => this.searching = true),
                switchMap(() => {
                    let search = this.form.get('language').value;
                    if (this.languagesSearch.value) {
                        search = this.languagesSearch.value;
                    }
                    return this._dropdownsService.getLanguages();
                })
            )
            .subscribe((data: any) => {
                this.searching = false;
                this.languages = data.body;
            });
        merge(this.searchLanguages.valueChanges)
            .pipe(
                startWith(''),
                tap(),
                switchMap(() => {
                    return this._dropdownsService.getLanguages();
                })
            )
            .subscribe((data: any) => {
                this.communicationLanguages = data.body;
                console.log(this.communicationLanguages);
                if (this.searchLanguages.value !== '') {
                    this.communicationLanguages = FuseUtils.filterArrayByString(this.communicationLanguages, this.searchLanguages.value);
                    console.log(this.communicationLanguages);
                }
            });
    }

    onChangePartnertitle(index: any): void {
        console.log(this.form.get(`partners.${index}.title`).value);
        const title = this.form.get(`partners.${index}.title`).value;
        if (title === 'Mr.') {
            this.form.get(`partners.${index}.gender`).setValue('Male');
        }
        if (title === 'Ms.' || title === 'Mrs.' || title === 'Miss.') {
            this.form.get(`partners.${index}.gender`).setValue('Female');
        }
    }

    // setAddress(address: any): void {
    //     const country = _.find(address.address_components, (component: any) => component.types.indexOf('country') > -1);
    //     const region = _.find(address.address_components, (component: any) => component.types.indexOf('administrative_area_level_1') > -1);
    //     const province = _.find(address.address_components, (component: any) => component.types.indexOf('administrative_area_level_2') > -1);
    //     const city = _.find(address.address_components, (component: any) => component.types.indexOf('locality') > -1);
    // }
    onLanguageChange(data: any): any {
        if (this.form.get('language').value.indexOf(data.key) > -1) {
            this.givenData.push(data.value);
            this.form.get('language_value').setValue(this.givenData);
        }
        else{
            remove(this.form.get('language_value').value, (n: any) => {
                if ( data.value['en'] && n['en'] && data.value['en'] === n['en']){
                    return n;
                } 
                else{
                    return n === data.value;
                }
            });
        }
        console.log(this.form.value);
    }
    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
